import './App.css'
import ContactUs from './pages/ContactUs'
import { ToastContainer } from "react-toastify";
import TermAndCondition from './pages/TermAndCondition';
import PolicyAndPrivacy from './pages/PolicyAndPrivacy';
import { Route, Routes } from 'react-router-dom';

function App() {


  return (
    <div className='w-full'>
        <ToastContainer/>
        <div className="loader">
          <div className="loader__content"></div>
        </div>
        <Routes>
        <Route path='/' element={<ContactUs />} />
        <Route path='/contactus' element={<ContactUs />} />
        <Route path='/termandcondition' element={<TermAndCondition />} />
        <Route path='/policyandprivacy' element={<PolicyAndPrivacy />} />
        {/* 404 fallback */}
        <Route path='*' element={<div>404 — Page not found</div>} />
        </Routes>
    
    </div>
  )
}

export default App
